/**
 * Giá trị id báo cáo chọn trong đối chiếu số dư dvc
 */
export default {
  MS01a: 1,
  MS02a: 2,
  MS04: 4,
  MS06: 6,
};
